'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function () {
  $('.main-carousel').slick({
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    responsive: [{
      breakpoint: 1050,
      settings: {
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2500,
        dots: false
      }
    }]
  });
  $('.content__slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  // product-card sliders
  $('.product__slider--main').slick({
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.product__slider--nav'
  });
  $('.product__slider--nav').slick(_defineProperty({
    arrows: false,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    asNavFor: '.product__slider--main'
  }, 'focusOnSelect', true));
};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/components/sliders.js
// module id = 5
// module chunks = 0